import {
  QUESTIONNAIRE_TASK_CODE,
  QUESTIONNAIRE_TASK_CODE_SYSTEM,
} from "../constants/questionnaireTaskFhirConstants";

/**
 * Indica se uma Task FHIR representa envio/resposta de questionário.
 *
 * Critérios (OR):
 * - `code.coding` contém system+code do questionário; ou
 * - `focus.reference` aponta para Questionnaire/ (fallback para recursos antigos).
 */
export function isQuestionnaireTask(task: unknown): task is fhir5.Task {
  if (!task || typeof task !== "object") return false;
  const t = task as fhir5.Task;
  const codings = t.code?.coding;
  if (Array.isArray(codings)) {
    const hasProfileCode = codings.some(
      (coding) =>
        coding.system === QUESTIONNAIRE_TASK_CODE_SYSTEM &&
        coding.code === QUESTIONNAIRE_TASK_CODE,
    );
    if (hasProfileCode) return true;
  }
  const focusRef = t.focus?.reference;
  return (
    typeof focusRef === "string" && focusRef.trim().startsWith("Questionnaire/")
  );
}
